// Minimal shim. Later, swap the mock with your LLM/vision API of choice.
export type ParsedDoc = {
  amountAED: number | null;
  dueDate?: string;           // ISO
  issuer?: string;            // School/Hospital/Clinic
  lineItems?: Array<{ label: string; amountAED?: number }>;
  rawText?: string;
};

export async function parseInvoiceOrQuote(file: File): Promise<ParsedDoc> {
  // Configuration for AI API (set these in your environment)
  const AI_API_BASE = import.meta.env.VITE_AI_API_BASE || "";
  const AI_API_KEY = import.meta.env.VITE_AI_API_KEY || "";
  
  // TODO: Replace with real AI API call when ready
  // Example implementation:
  // if (AI_API_BASE && AI_API_KEY) {
  //   const formData = new FormData();
  //   formData.append('file', file);
  //   const response = await fetch(`${AI_API_BASE}/parse`, {
  //     method: 'POST',
  //     headers: { 'Authorization': `Bearer ${AI_API_KEY}` },
  //     body: formData
  //   });
  //   return await response.json();
  // }
  
  // For now: mock parse using filename heuristics and return a deterministic demo
  const name = file.name.toLowerCase();
  const guess = name.includes("tuition") ? 56000 : name.includes("ivf") ? 28000 : 18000;
  return {
    amountAED: guess,
    dueDate: new Date(Date.now() + 1000 * 60 * 60 * 24 * 21).toISOString().slice(0, 10),
    issuer: name.includes("hospital") ? "Private Hospital (Demo)" : name.includes("school") ? "School (Demo)" : "Issuer (Demo)",
    lineItems: [{ label: "Base fee", amountAED: Math.round(guess * 0.9) }, { label: "VAT/Other", amountAED: Math.round(guess * 0.1) }],
    rawText: `Parsed from ${file.name}`
  };
}

export function explainPlanHumanReadable(plan: {
  breakdown: { bnplAED?: number; bankFinanceAED?: number; upfrontAED?: number };
  tenureMonths?: number;
}): string {
  const b = plan.breakdown;
  const parts: string[] = [];
  if (b.bnplAED) parts.push(`BNPL ~ AED ${b.bnplAED.toLocaleString()}`);
  if (b.bankFinanceAED) parts.push(`Finance ~ AED ${b.bankFinanceAED.toLocaleString()}`);
  if (b.upfrontAED) parts.push(`Upfront ~ AED ${b.upfrontAED.toLocaleString()}`);
  return `${parts.join(" + ")}${plan.tenureMonths ? ` • ~${plan.tenureMonths} mo` : ""}`;
}